import React, { useEffect, useState, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Field, reduxForm } from 'redux-form';
import { ButtonToolbar, Button, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const ShiftFilter = (props) => {
  const { t, filterClick, initialize, lastFilter } = props;
  const [filter, setFilter] = useState();

  const filterCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      setFilter(updatedFilter);
    }
  };

  useEffect(() => {
    setFilter(lastFilter);
    initialize(lastFilter);
  }, [lastFilter]);

  return (
    <MuiThemeProvider>
      <Fragment>
        <div className="form">
          <div className="form__form-group-field">
            <Field
              name="active"
              component={renderCheckBoxField}
              defaultValue
              className="colored-click"
              onChange={filterCheckChange}
            />
            <Label className="generic__label">
              {t('general.only-actives')}
            </Label>
          </div>
        </div>
        <ButtonToolbar
          className="form__button-toolbar"
          style={{ justifyContent: 'flex-end' }}
        >
          <Button color="success" onClick={() => filterClick(filter)}>
            {t('general.filter')}
          </Button>
        </ButtonToolbar>
      </Fragment>
    </MuiThemeProvider>
  );
};

ShiftFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(
    PropTypes.shape({
      id: PropTypes.number,
      active: PropTypes.bool,
    })
  ).isRequired,
};

export default reduxForm({
  form: 'ShiftFilterForm',
})(withTranslation('common')(ShiftFilter));
